var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInjuryHandRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 40,
    viewBox: "0 0 24 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1 1 .743 18.28c4.555 6.216 7.013 10.292 7.373 12.23.541 2.908 8.002 7.632 11.752 7.059 3.75-.574 2.123-10.71-.666-15.911-2.79-5.201-1.777-3.326-1.777-8.796 0-3.646-1.076-6.233-3.226-7.758-2.575-1.48-3.862-3.18-3.862-5.104H1z",
    fill: "#FC5A56",
    stroke: "#FC5A56",
    fillRule: "evenodd",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInjuryHandRight);
export default __webpack_public_path__ + "static/media/injury-hand-right.9295069501032ed25553d2e324d182f7.svg";
export { ForwardRef as ReactComponent };